import { WORKFLOW_LIMITS } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import type { DropView } from "./connector-context";

const K = "engage.workflows.connectors";

/**
 * The outline of a tile while a connector is dragged (or just after "Go to"): a tile that can take the connector gets a
 * brand outline, the one under the pointer a solid one; a tile that cannot is dimmed. The outline never says it alone: the chip does.
 */
export function dropRing(view: DropView | null, highlighted: boolean): string {
  if (view?.kind === "invalid") return "ring-1 ring-inset ring-line opacity-60";
  if (highlighted || view?.over) return "ring-2 ring-inset ring-primary-ink";
  return view ? "ring-2 ring-inset ring-primary-ink/40" : "ring-1 ring-inset ring-line";
}

/** A tile's text label while a connector is dragged: "Drop to connect", or why it cannot be the end ("Same path"). */
export function DropChip({ view }: { view: DropView | null }) {
  const { t } = useTranslation();
  if (!view) return null;
  if (view.kind === "valid") {
    return <span className="absolute -top-2.5 right-3 z-10 rounded-pill bg-primary px-2 py-0.5 text-[10px] font-bold text-on-primary" data-testid="drop-chip" data-drop="valid">{t(`${K}.drop`)}</span>;
  }
  return (
    <span className="absolute -top-2.5 right-3 z-10 rounded-pill border border-line bg-sunken px-2 py-0.5 text-[10px] font-bold text-fg-muted" data-testid="drop-chip" data-drop="invalid">
      {t(`${K}.reasons.${view.reason}`, { max: WORKFLOW_LIMITS.paths })}
    </span>
  );
}
